/**
 * 向当前 URL 添加或更新查询参数
 * @param paramName 参数名
 * @param paramValue 参数值
 */
export const addOrUpdateURLParam = (
  paramName: string,
  paramValue: string
): void => {
  // 获取当前页面的 URL
  const currentUrl = window.location.href

  // 创建 URL 对象
  const url = new URL(currentUrl)

  // 更新或添加查询参数
  url.searchParams.set(paramName, paramValue)

  // 可以选择将修改后的 URL 应用到页面（例如：跳转或更新地址栏）
  window.history.pushState({}, '', url.toString())
}

/**
 * 获取当前 URL 中指定查询参数的值
 * @param paramName 查询参数的名称
 * @returns 如果存在该参数，返回参数值；否则返回 null
 */
export const getQueryParam = (paramName: string): string | null => {
  // 从当前页面的 URL 查询字符串中创建 URLSearchParams 实例
  const urlParams = new URLSearchParams(window.location.search)

  // 获取指定名称的查询参数值
  const paramValue = urlParams.get(paramName)

  // 返回查询参数值，如果没有找到，则返回 null
  return paramValue
}

/**
 * 删除当前 URL 中指定的查询参数
 * @param paramName 要删除的查询参数名
 */
export const removeURLQueryParam = (paramName: string): void => {
  // 获取当前页面的 URL
  const currentUrl = window.location.href

  // 创建 URL 对象
  const url = new URL(currentUrl)

  // 删除指定的查询参数
  url.searchParams.delete(paramName)

  // 更新浏览器的地址栏，去除查询参数
  window.history.pushState({}, '', url.toString())
}
